/**
 * Created by Ning Jiang on 2024-03-20.
 */

import {DeadwoodRipSymbol} from "./DeadwoodRipSymbol";
import {DeadwoodRipSymbolState} from "./DeadwoodRipSymbolConfig";
import {TimelineLite} from "gsap";
import {DeadwoodRipSound} from "../sound/DeadwoodRipSound";

export class DeadwoodRipCharacterSymbol extends DeadwoodRipSymbol {

    constructor(symbolName:string, reelId:number, initState:DeadwoodRipSymbolState) {
        super(symbolName, reelId, initState);
    }

    protected getOnShotAnimationName():string {
        return `${this.reelId === 4 ? "2" : "1"}x${parseInt(this.symbolName[1]) > 3 ? "Busted" : "Wanted"}_Shoot`;
    }

    protected getDeadLoopAnimationName():string {
        return `${this.stackedSymbolName.symName}DeadLoop`;
    }

    protected playGunShotSound(stereoIndex:number):TimelineLite {
        return DeadwoodRipSound.getDefaultGunShotBodyTimeline(stereoIndex);
    }

    protected playKillSound():void {
        DeadwoodRipSound.playSymbolKill(this.symbolName, this.reelId);
    }
}